import React from 'react';
import { translate } from '@utils/i18n';
import { SubcontractorDocumentGroup } from './components/SubcontractorDocumentGroup';
import { SUBCONTRACTOR_DOCUMENTS_NS } from './constants';
import './SubcontractorDocumentsStyles.scss';
/**
 * The subcontractor side of the Documents tab: one `AttachmentsSurface` per document type.
 *
 * Rendered by `DocumentsList` for the `!isPrime` branch when direct uploads are on — this is not
 * a `react_component` mount of its own, so it inherits that island's `QueryClientProvider`.
 *
 * The grouping is `Subcontractors::DocumentType`, not a free-form category — types carry
 * `is_required` and `has_multiple`, are configured elsewhere, and cannot be created from here.
 * That is why this screen renders N surfaces rather than one table with a Type column: each type
 * is its own workspace with its own Add action, and the drawer opened from a type's header is
 * bound to it.
 */
export function SubcontractorDocumentsSurface({ groups, parentType, parentId }) {
    if (groups.length === 0) {
        return (React.createElement("p", { className: "subcontractor-documents__empty" }, translate('no_document_types', { namespace: SUBCONTRACTOR_DOCUMENTS_NS })));
    }
    return (React.createElement("div", { className: "subcontractor-documents" },
        groups.map((group) => (React.createElement("div", { className: "subcontractor-documents__group", key: group.documentTypeId },
            React.createElement(SubcontractorDocumentGroup, { group: group, parent: { parentType, parentId } })))),
        React.createElement("p", { className: "subcontractor-documents__legend" }, translate('required_legend', { namespace: SUBCONTRACTOR_DOCUMENTS_NS }))));
}
